import React from "react";
import T from "prop-types";
import { TENANT_LOCATION } from "MODULES/shared/components/ShippingSection/shippingTypes";
import Warning from "MODULES/shared/components/Warning/Warning";

function BioHazmatWarning({ parts, shippingType }) {
  if (
    shippingType === TENANT_LOCATION &&
    parts &&
    parts.some(p => p.bio_hazmat)
  ) {
    return (
      <Warning warningType="danger">
        Part is labeled bio-hazardous. If in as removed condition, please
        consider shipping directly to repair station.
      </Warning>
    );
  }

  return null;
}

export default BioHazmatWarning;

BioHazmatWarning.propTypes = {
  parts: T.arrayOf(T.shape({})),
  shippingType: T.string
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/shared/BioHazmatWarning.jsx